import React, {Component} from 'react';
import {Field} from 'redux-form';
import { connect } from 'react-redux'

import PubSub from "pubsub-js";
import * as pubSubMessages from "../../../store/pubSubMessages";
import ReduxInputComponent from "../ReduxComponent/ReduxInputComponent";

class BodyMassIndex extends Component {
    state = {
        height: this.props.height, weight: this.props.weight
    };

    bodyIndex = () => {
        if (this.state.height && this.state.weight) {
            let bodyIndex = Math.round(100000*this.state.weight / (this.state.height*this.state.height))/10;
            if ((bodyIndex > 10) && (bodyIndex < 60)) return bodyIndex;
        }
        return '';
    }

    renderClassification = () => {
        const bodyIndex = this.bodyIndex();
        if (bodyIndex) {
            let msg = ''
            if (bodyIndex < 18.5) {
                msg = 'Less than 18.5 - Underweight';
            } else if (bodyIndex < 25) {
                msg = '18.5 to 24.9 - Healthy weight';
            } else if (bodyIndex < 30) {
                msg = '25 to 29.9 - Overweight but not obese';
            } else if (bodyIndex < 35) {
                msg = '30 to 34.9 - Obese class I';
            } else if (bodyIndex < 40) {
                msg = '35 to 39.9 - Obese class II';
            } else {
                msg = '40 or more - Obese class III';
            }
            return <div className="col-12 col-lg-12">
                <span className="label m-lg-0">{msg}</span>
            </div>
        }

        return null;
    }

    render = () => {
        return (
            <>
                <div className="col-12 col-lg-5">
                    <label htmlFor="bodyMass_height" className="m-lg-0">Your height, cm{this.props.required ? <sup>*</sup> : ''}</label>
                </div>
                <div className="col-12 col-lg-1">
                    <Field id="bodyMass_height"
                           autoComplete="off"
                           component={ReduxInputComponent}
                           type="text"
                           name="bodyMass_height"
                           className="form-control form-control-sm"
                           placeholder="cm"
                           numbersOnly={true}
                           onChange={ (event, newValue) => this.setState({height: newValue})}/>
                </div>
                <div className="col-12 col-lg-6">
                    <div className="row no-gutters ">
                        <div className="col-12 col-lg-6 border-left">
                            <div className="row no-gutters ">
                                <div className="col-12 col-lg-9">
                                    <label htmlFor="weight1" className="m-lg-0">Weight, kg{this.props.required ? <sup>*</sup> : ''}</label>
                                </div>
                                <div className="col-12 col-lg-3">
                                    <Field id="bodyMass_weight"
                                           autoComplete="off"
                                           component={ReduxInputComponent}
                                           type="text"
                                           name="bodyMass_weight"
                                           className="form-control form-control-sm"
                                           placeholder="kg"
                                           numbersOnly={true}
                                           onChange={ (event, newValue) => this.setState({weight: newValue})}/>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 border-left">
                            <div className="row no-gutters ">
                                <div className="col-12 col-lg-9">
                                    <label htmlFor="body1" className="m-lg-0">Body Mass Index</label>
                                </div>
                                <div className="col-12 col-lg-3">
                                    <input id="body1" type="text" className="form-control form-control-sm"
                                           placeholder=". . ." disabled={true} value={this.bodyIndex()} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.showClassification && this.renderClassification()}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        height: state.form.wizard.values.bodyMass_height,
        weight: state.form.wizard.values.bodyMass_weight
    }
}

export default connect(mapStateToProps)(BodyMassIndex);